import type { ThemePalette } from "./palette";

export function paletteToCSS(palette: ThemePalette): Record<string, string> {
  const vars: Record<string, string> = {
    "--color-sheet": palette.sheet,
    "--color-on-sheet": palette.onSheet,
    "--color-surface": palette.surface,
    "--color-on-surface": palette.onSurface,
    "--color-surface-warm": palette.surfaceWarm,
    "--color-card-surface": palette.cardSurface,
    "--color-border": palette.border,
    "--color-component-border": palette.componentBorder,
    "--color-muted": palette.muted,
    "--color-default": palette.default,
    "--color-placeholder": palette.placeholder,
    "--color-primary": palette.primary,
    "--color-on-primary": palette.onPrimary,
    "--color-ring": palette.ring,
    "--color-button-primary": palette.primary,
    "--color-on-button-primary": palette.onPrimary,
    "--color-button-secondary": palette.sheet,
    "--color-on-button-secondary": palette.muted,
    "--color-on-button-secondary-hover": palette.default,
    "--color-menu-item-hover": palette.menuItemHover,
    "--color-menu-item-selected": palette.menuItemSelected,
    "--color-selectable-hover": palette.selectableHover,
    "--color-selectable-selected": palette.selectableSelected,
    "--color-selectable-selected-hover": palette.selectableSelectedHover,
    "--color-button-primary-hover": palette.buttonPrimaryHover,
    "--color-button-secondary-hover": palette.buttonSecondaryHover,
    "--color-button-tertiary-hover": palette.buttonTertiaryHover,
    "--color-hover": palette.hover,
    "--color-chrome": palette.chrome,
    "--color-on-chrome": palette.onChrome,
    "--color-chrome-hover": palette.chromeHover,
    "--color-chrome-border": palette.chromeBorder,
    // Shadcn-scope overrides so markdown inherits theme
    "--background": palette.sheet,
    "--foreground": palette.default,
    "--muted": palette.surface,
    "--muted-foreground": palette.muted,
    "--border": palette.border,
    "--accent": palette.hover,
    "--accent-foreground": palette.default,
  };

  // Chart series are the scheme-harmonized source of truth. Emitting them here
  // (on :root) lets the lattice CSS fallback cover non-themed contexts while
  // the active theme drives every chart across the editor and miniapps.
  palette.chartSeries.forEach((color, index) => {
    vars[`--chart-${index + 1}`] = color;
  });

  return vars;
}
